import { IconRows, IconTruck, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { PriceTable, RegularBenefitVariant } from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: PriceTable
}

export function PriceTableView(props: Props) {
  const { onEdit, onRemove, config } = props

  const handleEdit = () => onEdit(RegularBenefitVariant.PriceTable)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconRows />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{config.value}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
